export const NAME = 'monitorings';

const CONTEXT = 'MONITORING::MONITORINGS';

const UPDATE_FILTERS = `${CONTEXT}::UPDATE::FILTERS`;

const SERVICE_GET = `${CONTEXT}::SERVICE::GET`;

const FETCH_START = `${CONTEXT}::FETCH::START`;
const FETCH_SUCCESS = `${CONTEXT}::FETCH::SUCCESS`;
const FETCH_ERROR = `${CONTEXT}::FETCH::ERROR`;

const RESET_STATE = `${CONTEXT}::RESET::STATE`;

const RESET = {
  STATE: RESET_STATE,
};

const SERVICE = {
  GET: SERVICE_GET,
};

const FETCH = {
  START: FETCH_START,
  SUCCESS: FETCH_SUCCESS,
  ERROR: FETCH_ERROR,
};

export const UPDATE = {
  FILTERS: UPDATE_FILTERS,
};

export const ACTION_TYPES = {
  RESET,
  SERVICE,
  FETCH,
  UPDATE,
};
